var _rect, _rect2, _path, _rect3, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHyperflexAllflash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 43.25,
    width: 26,
    height: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 59.25,
    width: 26,
    height: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.75,48V20h-1.5V31.25H66.58545l-1.85791-7.43213A.75009.75009,0,0,0,64,23.25H16a.75009.75009,0,0,0-.72754.56787L13.41455,31.25H10.75V16.75H62v-1.5H10a.7502.7502,0,0,0-.75.75V64a.7502.7502,0,0,0,.75.75H70a.7502.7502,0,0,0,.75-.75ZM16.58594,24.75H63.41406l1.62525,6.5H14.96069Zm-1.62525,38.5,1.62525-6.5H63.41406l1.62525,6.5Zm54.28931,0H66.58545l-1.85791-7.43213A.75009.75009,0,0,0,64,55.25H16a.75009.75009,0,0,0-.72754.56787L13.41455,63.25H10.75V48.75h58.5Zm-54.28931-16,1.62525-6.5H63.41406l1.62525,6.5Zm54.28931,0H66.58545l-1.85791-7.43213A.75009.75009,0,0,0,64,39.25H16a.75009.75009,0,0,0-.72754.56787L13.41455,47.25H10.75V32.75h58.5Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 27.25,
    width: 26,
    height: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.667,13.25H66.73438L68.624,10.416l-1.248-.832-2.667,4a.75.75,0,0,0,.624,1.166h3.93261L67.376,17.584l1.248.832,2.667-4a.75.75,0,0,0-.624-1.166Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 28,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 28,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 44,
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 44,
    r: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 44,
    r: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 60,
    r: 1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 60,
    r: 1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 60,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHyperflexAllflash);
export default __webpack_public_path__ + "static/media/icon_hyperflex_allflash.a9caeb07d466271b23adbd9644e4b917.svg";
export { ForwardRef as ReactComponent };